import { useDispatch, useSelector } from 'react-redux';
import {
  moveEditionSection,
  toggleEditionCardExpand,
  toggleEditionCardVisibility,
  toggleEditionTitleVisibility,
} from '@/store/slices/components/dashboard/DashboardSlice';

const MIN_INDEX_NORMAL = 0;
const MIN_INDEX_FOR_MINI_CARDS = 1;
const tabsWithMiniCards = ['overview', 'performance'];

// Hook to handle button callbacks
export default function useEditionButtonActions(tabId) {
  const dispatch = useDispatch();
  const { tabs } = useSelector((state) => state.DashboardSlice.edition);
  const minIndex = tabsWithMiniCards.includes(tabId)
    ? MIN_INDEX_FOR_MINI_CARDS
    : MIN_INDEX_NORMAL;

  const toggleHideCard = (sectionId, cardId) => {
    if (!tabId) return;
    dispatch(toggleEditionCardVisibility({ tabId, sectionId, cardId }));
  };

  const toggleHideTitle = (sectionId) => {
    if (!tabId) return;
    dispatch(toggleEditionTitleVisibility({ tabId, sectionId }));
  };

  const toggleExpand = (sectionId, cardId) => {
    if (!tabId) return;
    dispatch(toggleEditionCardExpand({ tabId, sectionId, cardId }));
  };

  const moveSection = (sectionId, direction) => {
    if (!tabId) return;
    dispatch(moveEditionSection({ tabId, sectionId, direction }));
  };

  const getOrderedSections = () => {
    const sections = tabs?.[tabId]?.sections || [];
    return sections
      .filter((section) => section?.id)
      .slice()
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
  };

  const isPrevDisabled = (sectionId) => {
    const orderedSections = getOrderedSections();
    if (!orderedSections.length) return true;

    const index = orderedSections.findIndex(
      (section) => section.id === sectionId
    );

    return index <= minIndex;
  };

  const isNextDisabled = (sectionId) => {
    const orderedSections = getOrderedSections();
    if (!orderedSections.length) return true;

    const index = orderedSections.findIndex(
      (section) => section.id === sectionId
    );

    return index < 0 || index >= orderedSections.length - 1;
  };

  return {
    isPrevDisabled,
    isNextDisabled,
    moveSection,
    toggleHideCard,
    toggleExpand,
    toggleHideTitle,
  };
}
